var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTuneAdjusted = function SvgTuneAdjusted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.004 4.193a.889.889 0 0 0-.337.696v3.555c0 .49.4.89.889.89.488 0 .888-.4.888-.89v-.888h.04a4.984 4.984 0 0 1-1.48-3.363M4.889 18.223a.892.892 0 0 1-.889-.89c0-.488.4-.888.889-.888h4.444v1.777zm0-10.667A.892.892 0 0 1 4 6.666c0-.488.4-.888.889-.888h8v1.778zm8 10.666v.89c0 .488-.4.888-.889.888a.892.892 0 0 1-.889-.889v-3.555c0-.49.4-.89.889-.89s.889.4.889.89v.889h6.222c.489 0 .889.4.889.888 0 .49-.4.89-.889.89zm-5.333-7.11v-.89c0-.489.4-.889.888-.889.49 0 .89.4.89.89v3.555c0 .489-.4.889-.89.889a.892.892 0 0 1-.888-.89v-.888H4.889A.892.892 0 0 1 4 12c0-.489.4-.889.889-.889zm11.555 0c.489 0 .889.4.889.888 0 .489-.4.889-.889.889h-8V11.11z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 17,
    y: 1,
    fill: "currentColor",
    className: "tune-adjusted_svg__adjustment-indicator",
    rx: 3
  })));
};
export default SvgTuneAdjusted;